'use client'

import Image from 'next/image'
import { useState } from 'react'
import type { PublicVenue } from './domain'
import { defaultVenueImage } from './venue-presentation'
import { externalBookingChannel } from './venue-source'

export function DiscoveryVenueImage({
  venue,
  alt,
  sizes,
  priority = false,
}: {
  venue: PublicVenue
  alt: string
  sizes: string
  priority?: boolean
}) {
  const external = externalBookingChannel(venue)
  const fallback = external?.imageFallbackUrl || defaultVenueImage
  const [failed, setFailed] = useState(false)
  const officialImage = external?.imagePresentation === 'official' && !failed
  const src = failed ? fallback : venue.imageUrl || fallback

  if (officialImage) {
    // Direct loading avoids copying or caching restaurant-owned social-preview imagery.
    // eslint-disable-next-line @next/next/no-img-element
    return <img
      src={src}
      alt={alt}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : 'auto'}
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  }

  return <Image
    src={src}
    alt={alt}
    fill
    sizes={sizes}
    priority={priority}
    onError={() => {
      if (!failed && src !== fallback) setFailed(true)
    }}
  />
}
